module.exports = __webpack_public_path__ + "static/media/breadcrumb04.2a693f17.png";